import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { IconButton, Stack, Typography } from '@mui/material';

import type { ActionItemSelection } from 'src/types/myFollowUp';
import useFollowUpActionTable from 'src/components/myFollowUp/FollowUpActionPage/components/FollowUpActionTable/FollowUpActionTableContext';
import ActionItemNavigationButtons from 'src/components/myFollowUp/MyFollowUpPage/FollowUpOverview/components/ActionItemNavigationButtons';

import useFollowUpTable from '../FollowUpTable/FollowUpTableContext';

import useFollowUpDetail from './FollowUpDetailContext';

import { styles } from './FollowUpDetailModalHeader.styles';

interface FollowUpDetailModalHeaderProps {
  closeModal: () => void;
  onRowSelect: (selectedRow: ActionItemSelection) => void;
  actionId?: number | null;
  useActionContext?: boolean;
}

const FollowUpDetailModalHeader: FC<FollowUpDetailModalHeaderProps> = ({
  closeModal,
  onRowSelect,
  actionId,
  useActionContext = false,
}) => {
  const { t } = useTranslation('myFollowUp');
  const actionTableContext = useFollowUpActionTable();
  const followUpTableContext = useFollowUpTable();

  const { actionItem } = useFollowUpDetail();

  const tableContext = useActionContext
    ? actionTableContext
    : followUpTableContext;

  const { setOffset, offset, ordering, pageSize } = tableContext;
  const actionItems = useActionContext
    ? actionTableContext.followUpActions
    : followUpTableContext.actionItems;
  return (
    <Stack
      direction="row"
      sx={{ justifyContent: 'space-between', height: '2.25rem' }}
    >
      <Stack direction="row" spacing={4}>
        {!!actionItem?.id && (
          <Stack direction="row" spacing={2}>
            <ActionItemNavigationButtons
              onRowSelect={onRowSelect}
              currentActionItemId={actionId}
              setOffset={setOffset}
              actionItems={actionItems}
              offset={offset}
              ordering={ordering}
              pageSize={pageSize}
              useActionContext={useActionContext}
            />
          </Stack>
        )}
        <Typography component="span" sx={styles.headline}>
          {t('header.ticket')}
          <Typography
            component="span"
            sx={[{ ml: 0.5 }, styles.headline, styles.headlineId]}
          >
            {actionItem?.id || '/'}
          </Typography>
        </Typography>
      </Stack>
      <IconButton onClick={closeModal}>
        <CloseRounded color="primary" />
      </IconButton>
    </Stack>
  );
};

export default FollowUpDetailModalHeader;
